export default __webpack_public_path__ + "static/media/t4.1ea03fc3.png";